import React, { ErrorInfo } from 'react';
import loadable from '@loadable/component';
import { FormattedMessage } from 'react-intl';
import { TextButton } from '../../../../components/button';
import { SearchFiltersRadioContent } from '../../search-filters-radio/SearchFiltersRadioContent';

const DatePicker = loadable(() =>
  import(
    /* webpackChunkName: "date-picker" */ '../../../../components/date-picker/DatePicker'
  ),
);

type Props = {
  onSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
  onChange: (date: Date | Date[]) => void;
  day?: Date;
};

export class DayPicker extends React.Component<Props> {
  componentDidCatch(error: Error, info: ErrorInfo) {
    console.log(error, info);
    if (window.Rollbar) window.Rollbar.critical(error, { source: 'daypicker' });
  }

  render() {
    const { day, onChange, onSubmit } = this.props;
    return (
      <SearchFiltersRadioContent>
        <form onSubmit={onSubmit}>
          <DatePicker
            calendarIcon={null}
            clearIcon={null}
            onChange={onChange}
            value={day}
          />
          <TextButton type="submit">
            <FormattedMessage id="search/components/aside-filters/dates/DayPicker.tsx/1" />
          </TextButton>
        </form>
      </SearchFiltersRadioContent>
    );
  }
}
